export enum LessonEvent {
  FINISH_LESSON = 'finishLesson',
  TOGGLE_INDEX = 'toggleIndex',
  REQUEST_USER_INFO = 'requestUserInfo',
  SEND_USER_INFO = 'sendUserInfo',
  REQUEST_LESSON_INFO = 'requestLessonInfo',
  SEND_LESSON_INFO = 'sendLessonInfo',
  REFERRAL_BUTTON_CLICKED = 'referralButtonClicked',
  SEND_CHAT_BOT_LESSON_INFO = 'sendChatBotLessonInfo',
  OPEN_CHAT_BOT_LESSON = 'openChatBotLesson',
}
